export interface ISettingsStorage {
    showCalibrationsPanelJobPage: boolean;
    showCalibrationsPopupJobPage: boolean;
    showGaugePanelJobPage: boolean;
    showFeaturesPanelJobPage: boolean;
    showStepByStepOptionJobPage: boolean;
    showHeader: boolean;
    showChangeCutter: boolean;
    showReanalyze: boolean;
    showCalibrationOptions: boolean;
}

export function loadSettings(): ISettingsStorage {
    try {
        const stored = JSON.parse(localStorage.getItem("storage"));
        return stored ? stored : {
            showCalibrationsPanelJobPage: true,
            showCalibrationsPopupJobPage: true,
            showFeaturesPanelJobPage: true,
            showGaugePanelJobPage: true,
            showHeader: true,
            showStepByStepOptionJobPage: true,
            showChangeCutter: true,
            showReanalyze: true,
            showCalibrationOptions: true,
        } satisfies ISettingsStorage;

    } catch (error) {
        return {
            showCalibrationsPanelJobPage: true,
            showCalibrationsPopupJobPage: true,
            showFeaturesPanelJobPage: true,
            showGaugePanelJobPage: true,
            showHeader: true,
            showStepByStepOptionJobPage: true,
            showChangeCutter: true,
            showReanalyze: true,
            showCalibrationOptions: true,
        } satisfies ISettingsStorage;
    }
}
